<div #tagsContainer class="resume-col" [class.is-ready]="isReady()">
  <div class="tags-wrapper">
    @for (tag of displayTags(); track tag.indicatorId + '|' + (tag.relationshipLevel ?? ''); let i = $index) {
      <app-tag [id]="'alert-tag-' + i" [type]="tag.type" [style.display]="tag.visible ? 'block' : 'none'">
        {{ tag.text }}
      </app-tag>
    }
  </div>

  @if (hiddenTagsCount()) {
    <app-tag [id]="'alert-tag-hidden'" type="info">
      {{ hiddenTagsText() }}
    </app-tag>
  }
</div>
